export function chartRatio(value, maximum = 100) {
  if (value == null || !Number.isFinite(value) || !Number.isFinite(maximum) || maximum <= 0) return null;
  return Math.min(Math.max(value / maximum, 0), 1);
}

export function chartLabelIndexes(length, width) {
  const count = Math.min(length, Math.max(2, Math.floor(width / 86)));
  return new Set(Array.from({ length: count }, (_, index) => (
    Math.round(index * (length - 1) / Math.max(count - 1, 1))
  )));
}

// Percent axis that starts below the lowest value: at most 50 %, by tens, never below 0.
export function adaptivePercentTicks(values = []) {
  const finite = values.filter((value) => value != null && Number.isFinite(value));
  const floor = Math.min(50, Math.floor(((finite.length ? Math.min(...finite) : 0) - 5) / 10) * 10);
  const step = 100 - floor <= 60 ? 10 : 20;
  const minimum = Math.max(0, Math.floor(floor / step) * step);
  return Array.from({ length: (100 - minimum) / step + 1 }, (_, index) => minimum + index * step);
}
